import React, { useEffect } from 'react'
import { endOfDay } from 'date-fns'

import { Calendar } from '../../containers'
import { addDays, startOfWeek } from '../../helpers/date'
import { setSelectedDays } from '../../redux/@interface/calendar/calendarReducer'
import { getScheduleShifts } from '../../redux/shifts/shiftsActions'
import { useTypedDispatch, useTypedSelector } from '../../redux/store'

export const ConnectedSchedule = () => {
    const dispatch = useTypedDispatch()

    const { selectedDays, timeMode } = useTypedSelector(state => state.calendarReducer)
    const { scheduleShifts, isLoading: isShiftsLoading } = useTypedSelector(state => state.pacoShiftsReducer)

    useEffect(() => {
        if (selectedDays.length === 0) {
            return
        }

        const startDate = selectedDays[0]
        const endDate = endOfDay(selectedDays[selectedDays.length - 1])

        dispatch(getScheduleShifts(startDate, endDate))
    }, [selectedDays])

    useEffect(() => {
        const weekStart = startOfWeek(new Date(), { weekStartsOn: 1 })
        const currentWeekDays = Array.from({ length: 7 }, (_, index) => addDays(weekStart, index))

        dispatch(setSelectedDays(currentWeekDays))
    }, [dispatch])

    return (
        <Calendar
            isLoading={isShiftsLoading}
            days={selectedDays}
            shifts={scheduleShifts}
            timeMode={timeMode}
            className="schedule"
        />
    )
}
